module.exports = __webpack_public_path__ + "static/media/64_tn.226a50c0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/polished/thumbnails/64_tn.jpg
// module id = 551
// module chunks = 0